import type {
  DomainAddressType,
  DomainExpenseType,
  DomainIncomeType,
} from "@porchpass/api-client";
import { getYearData } from "src/utils";

// Yeah, yeah. It's a function, not a constant. But this file is basically
// just all the data items for dropdowns so...
// currentYear is also in utils/date.ts.
export const currentYear = new Date().getFullYear();
// Adding 1 because Date object starting index is 0
export const currentMonth = new Date().getMonth() + 1;

export const year_data = getYearData();
export const generic_page_error_message =
  "Please contact your dealer representative if this issue persists.";

export const month_data = [
  { id: "01", label: "1-January" },
  { id: "02", label: "2-February" },
  { id: "03", label: "3-March" },
  { id: "04", label: "4-April" },
  { id: "05", label: "5-May" },
  { id: "06", label: "6-June" },
  { id: "07", label: "7-July" },
  { id: "08", label: "8-August" },
  { id: "09", label: "9-September" },
  { id: "10", label: "10-October" },
  { id: "11", label: "11-November" },
  { id: "12", label: "12-December" },
];

export const account_type = [
  { id: "CHECKING", label: "Checking" },
  { id: "SAVINGS", label: "Savings" },
  { id: "BONDS", label: "Bonds" },
  { id: "CASH_VALUE_OF_LIFE_INSURANCE", label: "Cash Value of Life Insurance" },
  { id: "CERTIFICATE_OF_DEPOSIT", label: "Certificate of Deposit" },
  { id: "MUTUAL_FUNDS", label: "Mutual Funds" },
  { id: "OTHER_REAL_ESTATE", label: "Other Real Estate" },
  { id: "RETIREMENT", label: "Retirement" },
  { id: "STOCKS", label: "Stocks" },
  { id: "TRUST_ACCOUNT", label: "Trust Account" },
  { id: "OTHER", label: "Other" },
];

export const housing_type_data = [
  { id: "OWN", label: "Own (I’m still paying it off)" },
  { id: "RENT", label: "Rent" },
  {
    id: "NO_PRIMARY_HOUSING_EXPENSE",
    label: "No Housing Expense / Living with family",
  },
  { id: "OTHER", label: "Other" },
];

type IncomeOptionShape = { title: string; income_type: DomainIncomeType };
export const IncomeOptions: IncomeOptionShape[] = [
  { title: "SSI", income_type: "SSI" },
  { title: "Disability", income_type: "DISABILITY" },
  { title: "SSI for dependents", income_type: "SSI_FOR_DEPENDENTS" },
  { title: "VA disability", income_type: "VA_DISABILITY" },
  { title: "Retirement/Pension/401k", income_type: "RETIREMENT" },
  { title: "Alimony", income_type: "ALIMONY" },
  { title: "Child Support", income_type: "CHILD_SUPPORT" },
  { title: "Rental Income", income_type: "RENTAL" },
  { title: "WIC", income_type: "WIC" },
  { title: "TANF", income_type: "TANF" },
  { title: "SNAP", income_type: "SNAP" },
  { title: "Other", income_type: "OTHER" },
];

type AddressOptionsShape = { title: string; address_type: DomainAddressType }[];
export const AddressOptions: AddressOptionsShape = [
  {
    title: "Current Address",
    address_type: "CURRENT",
  },
  {
    title: "Previous Address",
    address_type: "PREVIOUS",
  },
  {
    title: "Mailing Address",
    address_type: "MAILING",
  },
];

type ExpenseOptionShape = { title: string; expense_type: DomainExpenseType };
export const ExpenseOptions: ExpenseOptionShape[] = [
  {
    title: "Alimony/Maintenance",
    expense_type: "ALIMONY",
  },
  {
    title: "Child Support",
    expense_type: "CHILD_SUPPORT",
  },
  {
    title: "Garnishment",
    expense_type: "GARNISHMENT",
  },
  {
    title: "Other",
    expense_type: "OTHER_SUPPORT",
  },
];

export type UpdatedAccountTypeOption = {
  id: string;
  label: string;
};

/** Total wizard steps shown in the DLA sticky header progress counter. */
export const DLA_STEP_TOTAL = 12;

export const progress_list_labels = [
  {
    key: "personal_info",
    titleText: "Personal and Household",
    url: "/personal-info",
  },
  { key: "address", titleText: "Address", url: "/address" },
  { key: "employment", titleText: "Employment", url: "/employment" },
  { key: "income", titleText: "Income", url: "/income" },
  {
    key: "financial_accounts",
    titleText: "Financial Accounts",
    url: "/financial-accounts",
  },
  { key: "expenses", titleText: "Expenses", url: "/expenses" },
  { key: "property", titleText: "Home and Land", url: "/home" },
  { key: "loan_overview", titleText: "Loan Overview", url: "/overview" },
  { key: "demographics", titleText: "Demographic", url: "/ethnicity" },
  { key: "consent", titleText: "SSN and Consent", url: "/final-steps/consent" },
  {
    key: "sales_feedback",
    titleText: "Salesperson Details",
    url: "/final-steps/sales-person",
  },
];
